import { BreadcrumbItem } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { AuditBreadcrumbs } from '../../../components/breadcrumbs';

interface AodBreadcrumbsProps {
  items?: readonly BreadcrumbItem[];
  aodLink?: boolean;
}

export function AodBreadcrumbs({ items = [], aodLink = true }: AodBreadcrumbsProps) {
  const { formatMessage } = useIntl();

  const baseItems: BreadcrumbItem[] = [
    ...(aodLink
      ? [
          {
            content: formatMessage({
              id: 'audit.aod.titleLong',
              defaultMessage: 'Automatic Order Delivery',
            }),
          },
        ]
      : []),
    ...items,
  ];

  return <AuditBreadcrumbs items={baseItems} />;
}
